module.exports = __webpack_public_path__ + "assets/4db8d6f97967acbf7198cfc57228c00c.mp3";